<template>
  <v-content>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-container v-show="Details">
        <v-card style="border: 1px solid">
          <v-toolbar
              :color="appColor">
            <v-card-title class="headline mb-1">
              <span style="color:white"> Export รายชื่อผู้เข้าร่วมโครงการ</span>
            </v-card-title>
          </v-toolbar>
          <v-list-item>
            <v-row>
              <v-col
                  cols="12">
                <v-expand-transition>
                  <v-card v-if="!Details_Cordi"
                          style="border: 1px solid"
                  >
                    <v-list>
                      <v-list-item>
                        <v-row
                            justify="center"
                            class="d-flex justify-center">
                          <v-col
                              cols="12"
                              md="12">
                            <v-card-title>
                              ตารางข้อมูลรายละเอียดโครงการ
                              <v-spacer></v-spacer>
                              <v-text-field
                                  v-model="search"
                                  append-icon="mdi-magnify"
                                  label="ค้นหา รหัสโครงการ, โครงการ"
                                  single-line
                                  hide-details
                              ></v-text-field>
                            </v-card-title>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item class="d-flex justify-center">
                        <v-radio-group row
                                       v-model="TypeInsertProject"
                        >
                          <v-radio value="1" class="font-weight-bold" label="ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี"></v-radio>
                          <v-radio value="0" class="font-weight-bold" label="ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี"></v-radio>
                        </v-radio-group>
                      </v-list-item>
                      <v-list-item>
                        <v-row
                            justify="center"
                            class="justify-center">
                          <v-col
                              cols="12"
                              md="12"
                          >

                            <!--                        @click:row="GetData"-->
                            <v-data-table
                                :headers="courseHeaders"
                                :items="projectRegDataDump.filter(item => (TypeInsertProject == '1' ? item.Approve == '1' : item.Approve == '0'))"
                                :search="search"
                                item-key="D_Project_Register_id"
                                :single-expand="singleExpand"
                                :expanded.sync="expanded"
                                class="elevation-1"
                            >
                              <template v-slot:header.full_Name>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  โครงการ
                                </v-label>
                              </template>
                              <template v-slot:header.round>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  รอบที่
                                </v-label>
                              </template>
                              <template v-slot:header.round_name>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  ชื่อรอบ
                                </v-label>
                              </template>
                              <template v-slot:header.dateReg>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  วันที่
                                </v-label>
                              </template>
                              <template v-slot:header.time_start>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  เวลาเริ่ม
                                </v-label>
                              </template>
                              <template v-slot:header.time_end>
                                <v-label
                                    fontSize="16px"
                                    fontWeight="bold">
                                  เวลาสิ้นสุด
                                </v-label>
                              </template>
                              <template v-slot:item.full_Name="{ item }">
                                <div v-html="item.full_Name"></div>
                              </template>
                              <template v-slot:item.dateReg="{ item }">
                                {{ item.dateReg | dateToThai }}
                              </template>
                              <template v-slot:item.time_start="{ item }">
                                <span v-if="item.time_start != '00:00:00'">{{ item.time_start }}</span>
                                <span v-else> - </span>
                              </template>
                              <template v-slot:item.time_end="{ item }">
                                <span v-if="item.time_end != '00:00:00'">{{ item.time_end }}</span>
                                <span v-else> - </span>
                              </template>
                              <template v-slot:item.Project_Details="{ item }">
                                <v-btn
                                    text
                                    class="darken-3"
                                    color="green"
                                    @click="showDetails(item)"
                                >
                                  แสดงรายละเอียด
                                </v-btn>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-expand-transition>
              </v-col>
            </v-row>
          </v-list-item>
          <v-card-text>
            <v-row class="d-flex justify-center">
              <v-col
                  cols="12"
                  md="12">
                <template v-if="Details_Cordi">

                  <v-list-item>
                    <v-btn
                        outlined
                        color="#FF5722"
                        @click="showDetails">
                      ย้อนกลับ
                    </v-btn>
                  </v-list-item>

                  <v-card class="justify-center pa-6 mt-7">
                    <v-card-title
                        color="primary"
                        style="background-color: burlywood"
                    >
                      <div v-html="project.full_Name"></div>
                    </v-card-title>
                  </v-card>


                  <v-card class="mt-7">
                    <v-toolbar
                        :color="appColor"
                        dark
                        flat
                    >
                      <v-toolbar-title>รายชื่อผู้เข้าร่วมโครงการและลงทะเบียน ทั้งหมด
                        {{ JoinPerson.filter(item => item.status_reg_person == '1').length }} คน
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-text-field
                          v-model="searchPerson"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-card-title>
                    <v-list-item>
                      <v-row class="d-flex justify-center">
                        <v-col
                          cols="12"
                          md="6">
                          <v-select
                              v-model="selMenu"
                              :items="menu"
                              item-value="id"
                              item-text="text"
                          >
                            <template v-slot:item="{item}">
                              <h4 class="font-weight-bold" v-if="item.id == '1'">{{item.text}}
                                <span style="color: #364eff">{{JoinPerson.length}}</span>
                                รายการ
                              </h4>
                              <h4 class="font-weight-bold" v-else-if="item.id == '2'">{{item.text}}
                                <span style="color: #364eff">{{JoinPerson.filter(itemJ => itemJ.status_reg_person == '1').length}}</span>
                                รายการ
                              </h4>
                              <h4 class="font-weight-bold" v-else-if="item.id == '3'">{{item.text}}
                                <span style="color: #364eff">{{JoinPerson.filter(itemJ => itemJ.status_reg_person == '0').length}}</span>
                                รายการ
                              </h4>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-data-table
                        :headers="headersPerson"
                        :items="selMenu == '1' ? JoinPerson : selMenu == '2' ? JoinPerson.filter(itemJ => itemJ.status_reg_person == '1') : JoinPerson.filter(itemJ => itemJ.status_reg_person == '0')"
                        :search="searchPerson"
                    >
                      <template v-slot:item.type="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                        <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                        <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                        <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                        <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                        <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-list-item class="d-flex justify-center mt-6">
                    <!--                  <download-excel
                                          class="btn btn-default"
                                          :data="json_data"
                                          :fields="json_fields"
                                          worksheet="รายชื่อผู้เข้าร่วมโครงการ"
                                          :name="'รายชื่อผู้เข้าร่วมโครงการ ' + Project_name + '.xls'"
                                      >
                                        <v-btn outlined color="green" class="darken-3" @click="ExportData">
                                          Export รายชื่อผู้เข้าร่วมโครงการ
                                        </v-btn>
                                      </download-excel>-->
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12" md="6">
                        <v-btn outlined color="green" class="darken-3" @click="ExportData(true)">
                          Export รายชื่อผู้เข้าร่วมโครงการ (ใหม่)
                        </v-btn>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12" md="6">
                        <v-btn outlined color="green" class="darken-3" @click="ExportData(false)">
                          Export รายชื่อผู้เข้าร่วมโครงการ (สำเนา)
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <!--                <div v-html="html_data"></div>-->
                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            :color="appColor"
            dark
        >
          <v-card-text>
            Loading...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-content>
</template>

<script>
import axios from "axios";
import ConstData from "../../const/Const";
import {mapActions, mapGetters} from "vuex";
import Vue from "vue";

export default {
  name: "ExportListData",
  data() {
    return {
      selMenu: '1',
      menu: [
        {text: 'ทั้งหมด', id: '1'},
        {text: 'ลงทะเบียน', id: '2'},
        {text: 'ไม่ลงทะเบียน', id: '3'},
      ],
      TypeInsertProject: '1',
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      html_data: '',
      json_fields: {
        'ลำดับ': 'index',
        "รหัสบุคลากร/นักศึกษา/อ้างอิงบุคคลภายนอก": 'uid',
        "ชื่อ - สกุล": 'full_Name',
        "สังกัด": 'affiliation',
        "ประเภท": 'type_details',
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      projectRegDataDump: [],
      Project_code_reg: '',
      dateReg: '',
      time_start: '',
      time_end: '',
      round: '',
      round_name: '',
      dialog_create: false,
      dialog_create_confirm: false,
      dialogLoading: false,
      ShowAlertSuc: false,
      MessageSuc: '',
      ShowAlertErr: false,
      MessageError: '',
      phoneOther: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      projectDataToTable: [],
      studentData: [],
      studentUniData: [],
      IdDepartStd: '',
      IdDepart: '',
      Idstudent: '',
      IdstudentUni: '',
      IdPersonal: '',
      personalMedData: [],
      AllDepartData: [],
      project: null,
      cardSel: '',
      staffSel: '',
      NameP: '',
      items: [],
      SurNameP: '',
      affiliation: '',
      position: '',
      idCard: '',
      NameStd: '',
      SurNameStd: '',
      affiliationStd: '',
      idCardStd: '',
      departSel: null,
      EmpData: [],
      TypeInsert: '0',
      open: [1, 2],
      isLoading: false,
      tree: [],
      types: [],
      Details: true,
      FileProject: [],
      alert: false,
      txtAlert: [],
      tab: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 5,
      vertical: false,
      altLabels: false,
      editable: true,
      Details_Cordi: false,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      Project_Choose: '',
      ProjectData: [],
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: '',
      course_group: '',
      Project_type: '',
      WorkBy: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '',
      CalCredit: '',
      PLACE: '',
      Province_id: '',
      Status: '',
      Remarks: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Project_name: '',
        Course_code: '',
        course_group: '',
        Project_type: '',
        WorkBy: '',
        Location: '',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        Project_group: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      searchPerson: '',
      headersPerson: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ประเภท', value: 'type'},
        {text: '', value: 'action'}
      ],
      JoinPerson: [],
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'}
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'}
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'ระดับ', value: 'Level'},
        {text: 'อายุงานเริ่มต้น', value: 'WSYear'},
        {text: 'อายุงานสิ้นสุด', value: 'WEYear'}
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในจังหวัด'
        },
        {
          id: '3', detail: 'ภายในประเทศ'
        },
        {
          id: '4', detail: 'ต่างประเทศ'
        },
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      courseHeaders: [
        {text: 'โครงการ', value: 'full_Name'},
        {text: 'รอบที่', value: 'round'},
        {text: 'ชื่อรอบ / รุ่น', value: 'round_name'},
        {text: 'วันที่', value: 'dateReg'},
        {text: 'เวลาเริ่ม', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'},
        {text: '', value: 'Project_Details'}
      ],
    }
  },
  computed: {
    bg() {
      return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      projectRegData: 'Project/getProjectReg',
      JoinProject: 'Project/getJoinProject',
      ProjectRound: 'Project/getProjectRound',
      ProjectExport: 'Project/getProjectExport',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      SubMenuPermiss: 'Permission/getSubMenuPermiss',
      IgnoreSubMenuPermiss: 'Permission/getIgnoreSubMenuPermiss',
      PermissionAdmin: 'Permission/getPermission',
      TypeProject: 'Project/getTypeProject',
      HeaderPage: 'Project/getHeaderPage',
      JoinProjectPage: 'Project/getManageProjectPage',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initProjectRegister: 'Project/initProjectRegister',
      getProjectRoundData: 'Project/getProjectRoundData',
      initProjectRoundData: 'Project/initProjectRoundData',
      initExportList: 'Project/initExportList',
      initJoinProject: 'Project/initJoinProject',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      getSubMenuPermissData: 'Permission/getSubMenuPermissData',
      getIgnoreSubMenuPermissData: 'Permission/getIgnoreSubMenuPermissData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      changeHeaderPage: 'Project/changeHeaderPage',
      changeJoinProjectPage: 'Project/changeManageProjectPage'
    }),
    init: function () {
      // this.initProjectRoundData().then(res => {
      //   if (res) {
          this.initProject()
      //   }
      // }).catch(reason => {
      //   if (reason) {
      //     this.initProject()
      //   }
      // })
    },
    initProject() {
      this.projectDataToTable = []
      this.projectRegDataDump = []
      // if (this.projectData.length == 0) {
      //   this.initProjectDataForApprove({
      //     query: 'Approve/1/Approve_Treasury/1'
      //   }).then(res => {
      //     if (res) {
      //       if (this.projectForApprove.length > 0) {
      //         this.projectDataToTable = this.projectForApprove.filter(item => item.Status != '2')
      //       }
      //     }
      //   })
      // }


      this.initDepartData()

      this.initPositionsData()

      if (this.staffData.length > 0) {
        this.staffData.map(item => {
          item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')'
        })
      }

      if (this.projectForApprove.length > 0) {
        if (this.CheckAdmin) {
          this.getPermissionDep({
            perid: this.MeData[0].perid
          }).then(resDep => {
            if (resDep) {
              this.initExportList({
                perid: this.MeData[0].perid,
                Project_type: this.TypeProject,
                type: 'admin',
              }).then(resExproj => {
                if (resExproj) {
                  this.projectRegDataDump = this.ProjectExport
                  this.dialogLoading = false
                }
              })

              /*this.projectForApprove.map((Project, idx) => {
                if (Project.Project_type == this.TypeProject && (Project.IsPlanStatus == '2' || Project.IsPlanStatus == '5' || Project.IsPlanStatus == '6' || Project.IsPlanStatus == '7' || Project.IsPlanStatus == '8')) {
                  if (Project.IsRoundStatus == '0') {
                    var DepData = this.Permission_Dep.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                    if (DepData.length > 0) {
                      this.projectDataToTable.push({
                        ...Project,
                        idx: this.projectDataToTable.length,
                        Ref_id: this.projectDataToTable.length,
                        full_Name: '<p style="font-weight: bold">' + Project.Project_name + '</p>' +
                            '<p>รหัส: (' + Project.Project_code + ')</p>'
                      })
                      // this.initProjectRegister({
                      //   dep_id: DepData[0].dep_id
                      // }).then(resProJ_Reg => {
                      //   if (resProJ_Reg) {
                      if (this.projectRegData.length > 0) {
                        this.projectRegData.map(Reg_I => {
                          if ((Reg_I.IsPlanStatus == '2' || Reg_I.IsPlanStatus == '5' || Reg_I.IsPlanStatus == '6' || Reg_I.IsPlanStatus == '7' || Reg_I.IsPlanStatus == '8') && Reg_I.IsRoundStatus == '0') {
                            var CheckDupe = this.projectRegDataDump.filter(item => item.Project_code == Reg_I.Project_code && item.D_project_round_id == Reg_I.D_project_round_id && item.round == Reg_I.round && item.D_Project_Register_id == Reg_I.D_Project_Register_id)
                            if (CheckDupe.length == 0) {
                              this.projectRegDataDump.push({
                                ...Reg_I,
                                idx: this.projectRegDataDump.length,
                                Ref_id: this.projectRegDataDump.length,
                                full_Name: '<p style="font-weight: bold">' + Reg_I.Project_name + '</p>' +
                                    '<p>รหัส: (' + Reg_I.Project_code + ')</p>'
                              })
                            }
                          }
                        })
                      }
                      //   }
                      // })
                    }
                  } else {
                    var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                    if (RoundDump.length > 0) {
                      RoundDump.map(RoundI => {
                        DepData = this.Permission_Dep.filter(Dep =>  Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                        if (DepData.length > 0) {
                          this.projectDataToTable.push({
                            ...RoundI,
                            idx: this.projectDataToTable.length,
                            Ref_id: RoundI.id,
                            full_Name: '<p style="font-weight: bold">' + RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )' + '</p>' +
                                '<p>รหัส: (' + RoundI.Project_code + ')</p>'
                          })

                          // this.initProjectRegister({
                          //   dep_id: DepData[0].dep_id
                          // }).then(resProJ_Reg => {
                          //   if (resProJ_Reg) {
                          this.projectRegData.map(Reg_I => {
                            if ((Reg_I.IsPlanStatus == '2' || Reg_I.IsPlanStatus == '5' || Reg_I.IsPlanStatus == '6' || Reg_I.IsPlanStatus == '7' || Reg_I.IsPlanStatus == '8') && Reg_I.IsRoundStatus == '1') {
                              var CheckDupe = this.projectRegDataDump.filter(item => item.Project_code == Reg_I.Project_code && item.D_project_round_id == Reg_I.D_project_round_id && item.round == Reg_I.round)

                              if (CheckDupe.length == 0) {
                                var RoundDump2 = this.ProjectRound.filter(roundI => roundI.Project_code == Reg_I.Project_code && roundI.id == Reg_I.D_project_round_id)
                                if (RoundDump2.length > 0) {
                                  this.projectRegDataDump.push({
                                    ...Reg_I,
                                    DateS: RoundDump2[0].DateS,
                                    DateE: RoundDump2[0].DateE,
                                    idx: this.projectRegDataDump.length,
                                    Ref_id: Reg_I.D_project_round_id,
                                    full_Name: '<p style="font-weight: bold">' + Reg_I.Project_name + ' -> ( รุ่น ' + RoundDump2[0].Round + ' ' + RoundDump2[0].Round_name + ' )' + '</p>' +
                                        '<p>รหัส: (' + Reg_I.Project_code + ')</p>'
                                  })
                                } else {
                                  this.projectRegDataDump.push({
                                    ...Reg_I,
                                    idx: this.projectRegDataDump.length,
                                    Ref_id: Reg_I.D_project_round_id,
                                    full_Name: '<p style="font-weight: bold">' + Reg_I.Project_name + ' -> ( ไม่พบรุ่น )' + '</p>' +
                                        '<p>รหัส: (' + Reg_I.Project_code + ')</p>'
                                  })
                                }

                              }
                            }
                          })
                          //   }
                          // })
                        }
                      })
                    }
                  }
                }
                if (idx == this.projectForApprove.length - 1) {
                  this.dialogLoading = false
                }
              })*/
            } else {
              this.dialogLoading = false
            }
          })
        } else if (this.CheckSubAdmin) {
          this.getPermissionDepUserData({
            perid: this.MeData[0].perid
          }).then(resDep => {
            if (resDep) {
              this.initExportList({
                perid: this.MeData[0].perid,
                Project_type: this.TypeProject,
                type: 'user',
              }).then(resExproj => {
                if (resExproj) {
                  this.projectRegDataDump = this.ProjectExport
                  this.dialogLoading = false
                }
              })

              /*this.projectForApprove.map((Project, idx) => {
                if (Project.Project_type == this.TypeProject && (Project.IsPlanStatus == '2' || Project.IsPlanStatus == '5' || Project.IsPlanStatus == '6' || Project.IsPlanStatus == '7' || Project.IsPlanStatus == '8')) {
                  if (Project.IsRoundStatus == '0') {
                    var DepData = this.Permission_Dep_User.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                    if (DepData.length > 0) {
                      this.projectDataToTable.push({
                        ...Project,
                        idx: this.projectDataToTable.length,
                        Ref_id: this.projectDataToTable.length,
                        full_Name: '<p style="font-weight: bold">' + Project.Project_name + '</p>' +
                            '<p>รหัส: (' + Project.Project_code + ')</p>'
                      })

                      // this.initProjectRegister({
                      //   dep_id: DepData[0].dep_id
                      // }).then(resProJ_Reg => {
                      //   if (resProJ_Reg) {
                      if (this.projectRegData.length > 0) {
                        this.projectRegData.map(Reg_I => {
                          if ((Reg_I.IsPlanStatus == '2' || Reg_I.IsPlanStatus == '5' || Reg_I.IsPlanStatus == '6' || Reg_I.IsPlanStatus == '7' || Reg_I.IsPlanStatus == '8') && Reg_I.IsRoundStatus == '0') {
                            var CheckDupe = this.projectRegDataDump.filter(item => item.Project_code == Reg_I.Project_code && item.D_project_round_id == Reg_I.D_project_round_id && item.round == Reg_I.round)

                            if (CheckDupe.length == 0) {
                              this.projectRegDataDump.push({
                                ...Reg_I,
                                idx: this.projectRegDataDump.length,
                                Ref_id: this.projectRegDataDump.length,
                                full_Name: '<p style="font-weight: bold">' + Reg_I.Project_name + '</p>' +
                                    '<p>รหัส: (' + Reg_I.Project_code + ')</p>'
                              })
                            }
                          }
                        })
                      }
                      //   }
                      // })
                    }
                  } else {
                    var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                    if (RoundDump.length > 0) {
                      RoundDump.map(RoundI => {
                        DepData = this.Permission_Dep_User.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                        if (DepData.length > 0) {
                          this.projectDataToTable.push({
                            ...RoundI,
                            idx: this.projectDataToTable.length,
                            Ref_id: RoundI.id,
                            full_Name: '<p style="font-weight: bold">' + RoundI.Project_name + ' -> ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ' )' + '</p>' +
                          '<p>รหัส: (' + RoundI.Project_code + ')</p>'
                          })

                          // this.initProjectRegister({
                          //   dep_id: DepData[0].dep_id
                          // }).then(resProJ_Reg => {
                          //   if (resProJ_Reg) {
                          this.projectRegData.map(Reg_I => {
                            if ((Reg_I.IsPlanStatus == '2' || Reg_I.IsPlanStatus == '5' || Reg_I.IsPlanStatus == '6' || Reg_I.IsPlanStatus == '7' || Reg_I.IsPlanStatus == '8') && Reg_I.IsRoundStatus == '1') {
                              var CheckDupe = this.projectRegDataDump.filter(item => item.Project_code == Reg_I.Project_code && item.D_project_round_id == Reg_I.D_project_round_id && item.round == Reg_I.round)

                              if (CheckDupe.length == 0) {
                                var RoundDump2 = this.ProjectRound.filter(roundI => roundI.Project_code == Reg_I.Project_code && roundI.id == Reg_I.D_project_round_id)
                                if (RoundDump2.length > 0) {
                                  this.projectRegDataDump.push({
                                    ...Reg_I,
                                    DateS: RoundDump2[0].DateS,
                                    DateE: RoundDump2[0].DateE,
                                    idx: this.projectRegDataDump.length,
                                    Ref_id: Reg_I.D_project_round_id,
                                    full_Name: '<p style="font-weight: bold">' + Reg_I.Project_name + ' -> ( รุ่น ' + RoundDump2[0].Round + ' ' + RoundDump2[0].Round_name + ' )' + '</p>' +
                                        '<p>รหัส: (' + Reg_I.Project_code + ')</p>'
                                  })
                                } else {
                                  this.projectRegDataDump.push({
                                    ...Reg_I,
                                    idx: this.projectRegDataDump.length,
                                    Ref_id: Reg_I.D_project_round_id,
                                    full_Name: '<p style="font-weight: bold">' + Reg_I.Project_name + ' -> ( ไม่พบรุ่น )' + '</p>' +
                                        '<p>รหัส: (' + Reg_I.Project_code + ')</p>'
                                  })
                                }

                              }
                            }
                          })
                          //   }
                          // })
                        }
                      })
                    }
                  }
                }
                if (idx == this.projectForApprove.length - 1) {
                  this.dialogLoading = false
                }
              })*/
            } else {
              this.dialogLoading = false
            }
          })
        }

        // this.projectDataToTable = this.projectData.filter(item => item.Status == '2')
      } else {
        this.dialogLoading = false
      }


      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT/FAC_ID/09/STUDY_STATUS/OK/?limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/rest/v1/AllPersonal/dss_person.W_FACULTY/1').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.AllDepartData = res.data
          } else {
            this.AllDepartData.push(res.data)
          }
        } else {
          this.AllDepartData = []
        }
      })

    },
    CheckPermissFunc(permiss) {
      var CheckPermiss = false
      return new Promise(resolve => {
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    ExportData(cordi) {
      if (cordi) {
        this.dialogLoading = true
        this.html_data = ''
        var countReg = 0
        var countNotReg = 0
        var html_content = ''
        var html_content2 = ''
        this.json_data = []
        if (this.JoinPerson.length > 0) {
          this.JoinPerson.map((item, idx) => {
            this.json_data.push({
              ...item,
              index: idx + 1,
              full_Name: item.name + ' ' + item.sname,
            })
            if (item.status_reg_person == '1') {
              html_content += '' +
                  '<tbody>' +
                  '<tr>' +
                  '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + (++countReg) + '</td>' +
                  '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + item.uid + '</td>' +
                  '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + item.name + ' ' + item.sname + '</td>' +
                  '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + item.affiliation + '</td>' +
                  '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + item.type_details + '</td>' +
                  '</tr>' +
                  '</tbody>'
            } else {
              html_content2 += '' +
                  '<tbody>' +
                  '<tr>' +
                  '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + (++countNotReg) + '</td>' +
                  '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + item.uid + '</td>' +
                  '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + item.name + ' ' + item.sname + '</td>' +
                  '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + item.affiliation + '</td>' +
                  '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + item.type_details + '</td>' +
                  '</tr>' +
                  '</tbody>'
            }
          })

          this.html_data = '' +
              '<div>' +
              '<table style="border-collapse: collapse;width: 100%">' +
              '<thead>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="5"><h2 style="text-align: center;font-weight: bold;">' + this.project.Project_name + ' (' + this.project.Project_code + ')</h2></th>' +
              '</tr>' +
              '<tr>' +
              // // '<th border="0" cellpadding="0" cellspacing="0" colspan="5"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่จัด ' + (this.project.date_start == this.project.date_end ? Vue.filter('DateToThai')(this.project.DateStart) : Vue.filter('DateToThai')(this.project.DateStart) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateEnd)) + '</p></th>' +
              // '<th border="0" cellpadding="0" cellspacing="0" colspan="5"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่จัด ' + (Vue.filter('DateToThai')(this.project.dateReg)) + '</p></th>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="5"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่จัด ' + (this.project.IsRoundStatus == '1' ? (this.project.DateS == this.project.DateE ? Vue.filter('DateToThai')(this.project.DateS) : Vue.filter('DateToThai')(this.project.DateS) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateE)) :
                  (this.project.DateStart == this.project.DateEnd ? Vue.filter('DateToThai')(this.project.DateStart) : Vue.filter('DateToThai')(this.project.DateStart) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateEnd))) + '</p></th>' +
              '</tr>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่ลงทะเบียน ' + (Vue.filter('DateToThai')(this.project.dateReg) + (this.project.time_start != '00:00:00' ? ' เวลา ' + this.project.time_start + ' น.': '') + (this.project.time_end != '00:00:00' ? ' - ' + this.project.time_end + ' น.': '')) + '</p></th>' +
              '</tr>' +
              '<tr style="margin-bottom: 20px">' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="5"><p style="text-align: center;font-weight: bold;font-size: 16px">สถานที่จัด ' + this.project.Location + '</p></th>' +
              '</tr>' +
              '<tr>' +
              '<br>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">รายชื่อผู้ลงทะเบียนเข้าร่วม</p></th>' +
              '</tr>' +
              '<tr>' +
              '<br>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ลำดับ</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">รหัสอ้างอิง</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ชื่อ - สกุล</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">สังกัด</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ประเภท</th>' +
              '</tr>' +
              '</thead>' +
              html_content +
              '</table>' +
              '<br>' +
              '<br>' +
              '<hr>' +
              '<br>' +
              '<br>' +
              '<table style="border-collapse: collapse;width: 100%">' +
              '<thead>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="5"><h2 style="text-align: center;font-weight: bold;">' + this.project.Project_name + ' (' + this.project.Project_code + ')</h2></th>' +
              '</tr>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="5"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่จัด ' + (this.project.IsRoundStatus == '1' ? (this.project.DateS == this.project.DateE ? Vue.filter('DateToThai')(this.project.DateS) : Vue.filter('DateToThai')(this.project.DateS) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateE)) :
                  (this.project.DateStart == this.project.DateEnd ? Vue.filter('DateToThai')(this.project.DateStart) : Vue.filter('DateToThai')(this.project.DateStart) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateEnd))) + '</p></th>' +
              // '<th border="0" cellpadding="0" cellspacing="0" colspan="5"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่จัด ' + (Vue.filter('DateToThai')(this.project.dateReg)) + '</p></th>' +
              '</tr>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่ลงทะเบียน ' + ('วันที่ ' + Vue.filter('DateToThai')(this.project.dateReg) + (this.project.time_start != '00:00:00' ? ' เวลา ' + this.project.time_start + ' น.': '') + (this.project.time_end != '00:00:00' ? ' - ' + this.project.time_end + ' น.': '')) + '</p></th>' +
              '</tr>' +
              '<tr style="margin-bottom: 20px">' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="5"><p style="text-align: center;font-weight: bold;font-size: 16px">สถานที่จัด ' + this.project.Location + '</p></th>' +
              '</tr>' +
              '<tr>' +
              '<br>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">รายชื่อผู้ไม่ได้ลงทะเบียนเข้าร่วม</p></th>' +
              '</tr>' +
              '<tr>' +
              '<br>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ลำดับ</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">รหัสอ้างอิง</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ชื่อ - สกุล</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">สังกัด</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ประเภท</th>' +
              '</tr>' +
              '</thead>' +
              html_content2 +
              '</table>' +
              '<br>' +
              '<p style="text-align: center;font-weight: bold">สรุปรายชื่อผู้สมัครเข้าร่วมจำนวน ' + this.JoinPerson.length + ' คน มีการลงทะเบียนจำนวน ' + this.JoinPerson.filter(item => item.status_reg_person == '1').length + ' คน ไม่ลงทะเบียนจำนวน ' + this.JoinPerson.filter(item => item.status_reg_person == '0').length + ' คน</p>' +
              '<br>' +
              '<br>' +
              '<br>' +
              '<p style="text-align: right;font-weight: bold">(.................................................................)</p>' +
              '<p style="text-align: right;font-weight: bold">(.................................................................)</p>' +
              '<p style="text-align: right;font-weight: bold;padding-right: 86px">ผู้รับรอง&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>' +
              '</div>'

          axios.post(ConstData.ConnectionHost + '/HrTrain2/Export2_QR.php', {
            Project_code: this.project.Project_code,
            title: this.project.Project_name,
            subject: this.project.Project_name,
            author: "",
            type: "1",
            id_Ref: this.project.Project_code,
            round_Ref: (this.project.IsRoundStatus == '0' ? null : this.project.Ref_id),
            D_Project_Register_id: this.project.D_Project_Register_id,
            perid: this.MeData[0].perid,
            html_data: this.html_data,
          }, {
            headers: {
              'Content-Type': 'application/json',
            }
          }).then(res => {
            if (res.data.status) {
              this.dialogLoading = false
              window.open(ConstData.ConnectionHost + '/HrTrain2/GetFileReport.php?file_name=' + res.data.path, '_blank');
            } else {
              this.dialogLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถดาวน์โหลดรายชื่อได้ โปรดลองอีกครั้ง หรือ ติดต่อผู้ดูแลระบบ'
              })
            }
          }).catch(res => {
            if (res) {
              this.dialogLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถดาวน์โหลดรายชื่อได้ โปรดลองอีกครั้ง หรือ ติดต่อผู้ดูแลระบบ'
              })
            }
          })
        } else {
          this.dialogLoading = false
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่พบรายชื่อผู้ลงทะเบียนเข้าร่วม'
          })
        }
      } else {
        this.dialogLoading = true
        var urlPath = (this.project.IsRoundStatus == '0' ? ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_report/D_Project_Register_id/' + this.project.D_Project_Register_id + '/active/1/?sort=id_DESC&limit=1' :
            ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_report/id_Ref/' + this.project.Project_code + '/round_Ref/' + this.project.Ref_id + '/active/1/?sort=id_DESC&limit=1')
        axios.get(urlPath).then(res => {
          if (res.data) {
            this.dialogLoading = false
            window.open(ConstData.ConnectionHost + '/HrTrain2/GetFileReport.php?file_name=' + res.data.file_name, '_blank');
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด ไม่พบข้อมูลสำเนารายชื่อ ผู้เข้าร่วมโครงการ!!'
            })
          }
        })
      }
    },
    showDetails: function (item) {
      if (this.Details_Cordi) {
        this.project = null
        this.Details_Cordi = false
      } else {
        this.project = item
        this.Details_Cordi = true;
        this.JoinPerson = []
        var url = ''
        this.Project_name = ''
        this.Project_name = item.full_Name
        this.selMenu = '1'
        this.initJoinProject({
          Project_code: item.Project_code
        }).then(resJoin => {
          if (resJoin) {
            if (item.IsRoundStatus == '0') {
              url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project_view/Project_code/' + item.Project_code + '/D_Project_Register_id/' + item.D_Project_Register_id + '/active/1/?limit=9999'
              this.JoinProject.map(Join_i => {
                this.JoinPerson.unshift({
                  ...Join_i,
                  full_Name: Join_i.name + ' ' + Join_i.sname,
                  idCard: Join_i.id_card,
                  status_reg_person: '0'
                })
              })
            } else {
              url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project_view/Project_code/' + item.Project_code + '/D_project_round_id/' + item.Ref_id + '/D_Project_Register_id/' + item.D_Project_Register_id + '/active/1/?limit=9999'
              this.JoinProject.map(Join_i => {
                if (Join_i.D_project_round_id == item.Ref_id) {
                  this.JoinPerson.unshift({
                    ...Join_i,
                    full_Name: Join_i.name + ' ' + Join_i.sname,
                    idCard: Join_i.id_card,
                    status_reg_person: '0'
                  })
                }
              })
            }
            axios.get(url).then(res => {
              if (res.data) {
                if (res.data.length > 0) {
                  this.JoinPerson.map(Join_i => {
                    res.data.map((item) => {
                      if (Join_i.uid == item.uid) {
                        Join_i.status_reg_person = item.status_reg_person
                      }
                    })
                  })
                } else {
                  this.JoinPerson.map(Join_i => {
                    if (Join_i.uid == res.data.uid) {
                      Join_i.status_reg_person = res.data.status_reg_person
                    }
                  })
                }
              }
              console.log(this.JoinPerson)
              // this.JoinPerson = this.JoinPerson.filter(item => item.status_reg_person == '1')
            })
          }
        })
      }
    },
    ChangeTypeProject() {

    },
    GetDateTime() {
      var date;
      date = new Date();
      date = date.getUTCFullYear() + '-' +
          ('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
          ('00' + date.getUTCDate()).slice(-2) + ' ' +
          ('00' + date.getUTCHours()).slice(-2) + ':' +
          ('00' + date.getUTCMinutes()).slice(-2) + ':' +
          ('00' + date.getUTCSeconds()).slice(-2);
      return date
    }
  },
  mounted() {
    this.dialogLoading = true
    this.changeHeaderPage({
      page: '2'
    })
    this.changeJoinProjectPage({
      page: '0'
    })
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreSubMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '10',
          page_sub_id: '10',
        })
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(resAdmin => {
          if (resAdmin) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '7000') {
                this.getSubMenuPermissData().then(res => {
                  if (res) {
                    if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                      this.maintain = false
                      this.init()
                    } else {
                      this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                      this.maintain = true
                      this.dialogLoading = false
                    }
                  }
                }).then(err => {
                  if (err) {
                    this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                    this.maintain = true
                    this.dialogLoading = false
                  }
                })
                this.CheckAdmin = true
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.dialogLoading = false
                  this.$router.push('/')
                }
              }
            })
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(resUser => {
              if (resUser) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '7000') {
                    this.getSubMenuPermissData().then(res => {
                      if (res) {
                        if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                          this.maintain = false
                          this.init()
                        } else {
                          this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                          this.maintain = true
                          this.dialogLoading = false
                        }
                      }
                    }).then(err => {
                      if (err) {
                        this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                        this.maintain = true
                        this.dialogLoading = false
                      }
                    })
                    this.CheckSubAdmin = true
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.dialogLoading = false
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.dialogLoading = false
                this.CheckSubAdmin = false
                this.CheckAdmin = false
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
